exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e-otp-container { gap: 10px; max-width: 320px; margin: 0 auto; }\n.e-otp-box {\n  width: 45px; height: 50px; text-align: center;\n  font-size: 20px; font-weight: bold; border: 1px solid #e6e8ea;\n  border-radius: 6px; outline: none; transition: border-color 0.2s;\n  color: #37474f;\n}\n.e-otp-box:focus { border-color: #007bff; box-shadow: 0 0 0 2px rgba(0,123,255,0.25); }\n.e-otp-box.invalid { border-color: #f44336; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/e-otp-input/e-otp-input.component.css
// module id = ../../../../../src/app/components/e-otp-input/e-otp-input.component.css
// module chunks = 3